/**
 * Brand utility functions for consistent brand elements across the app
 */

/**
 * Returns the Therappi brand name with registered trademark symbol
 */
export const THERAPPI_BRAND = 'Therappi®';

/**
 * Returns the full Therappi AI brand name with registered trademark
 */
export const THERAPPI_AI_BRAND = 'Therappi® AI';

/**
 * Brand support email
 */
export const THERAPPI_SUPPORT_EMAIL = 'support@therappi.app';

/**
 * Demo user email (used internally)
 */
export const THERAPPI_DEMO_EMAIL = 'support@therappi.app';
